<template>
  <div id="main-content" class="detail-student">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">Edit</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form>
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">Title:</span>
            <span class="info-span"> {{ attachmentInfo.title }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">File:</span>
            <!--<el-button type="success" @click="goToViewFile(attachment.file_url)" icon="el-icon-view">-->
              <!--View</el-button>-->
            <span class="info-span"> <el-button type="success" @click="goToViewFile(attachmentInfo.file_url)" icon="el-icon-view">
                View</el-button></span>
          </el-col>
        </el-row>

      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailAttachment",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/attachment`, title: "Attachment detail"
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        attachment_id: this.$route.query.aid
      }
      this.$store.dispatch('attachmentfile/getAttachmentInfo', payload)
    },
    computed: {
      ...mapState('attachmentfile', ['attachmentInfo']),
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/attachment/edit', query: {aid: this.$route.query.aid}});
      },
      goToViewFile(file_url){
        window.open(file_url, '_blank')
      }
    }
  }
</script>

<style lang="scss">
  .day-in-week {
    width: 100%;
    float: left;
    text-align: left;
    font-weight: bold;
  }

  .detail-student .info-span {
    width: 40%;
    text-align: left;
  }

  .day-in-week {
    width: 100%;
    float: left;
    text-align: left;
    font-weight: bold;
  }
</style>